<template>
  <div class="home" ref="menu">
    <div class="position-relative header-wrapper">
      <img src="../assets/success/1.png" alt="">
      <Header></Header>
      <div class="title-content">
        <div class="big-title animate__animated animate__fadeInDown">{{$t('success.title1')}}</div>
        <div class="small-title animate__animated animate__fadeInUp">{{$t('success.desc1')}}</div>
        <img class="animate__animated animate__bounceInUp" src="../assets/success/down.png" />
      </div>
    </div>
    <div class="serve-wrapper">
      <img class="bg-img" src="../assets/success/2.png" alt="">
      <div class="serve-content">
        <div class="top-content">
          <div class="animate__animated animate__fadeInDown">{{$t('success.title2')}} </div>
          <div class="animate__animated animate__fadeInUp">{{$t('success.title3')}}</div>
        </div>
        <div class="img-wrapper animate__animated">
          <div class="imgs">
            <img src="../assets/success/1-1.png" />
          </div>
          <div class="imgs">
            <img src="../assets/success/1-2.png" />
          </div>
          <div class="imgs">
            <img src="../assets/success/1-3.png" />
          </div>
          <div class="imgs">
            <img src="../assets/success/1-4.png" />
          </div>
          <div class="imgs">
            <img src="../assets/success/1-5.png" />
          </div>
          <div class="imgs">
            <img src="../assets/success/1-6.png" />
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>

</template>
<script>
import Header from "@/components/header";
import Footer from "@/components/footer";
  export default {
    components: {Header, Footer },
    data() {
      return {
      }
    },
    methods: {
    },
    mounted() {
      const io = new IntersectionObserver(entries => {
        entries.forEach(item => {
          if (item.isIntersecting) {
            if (item.target.classList[0] == 'img-wrapper') {
              item.target.classList.add('animate__zoomIn')
            }
          }
        })
      }, {})

      const nodeLists = [...document.querySelectorAll('.animate__animated')]
      nodeLists.forEach(box => {
        io.observe(box)
      })
    }
  }
</script>
<style lang="scss" scoped>
.header-wrapper {
  height: 632px;
}
.title-content {
  width: 100%;
  position: absolute;
  top: 175px;
  left: 0;
  right: 0;
  z-index: 11;
  .big-title {
    font-family: Microsoft YaHei;
    font-weight: bold;
    font-size: 67px;
    color: #FFFFFF;
    line-height: 67px;
  }
  .small-title {
    font-family: SourceHanSansCN;
    font-weight: 400;
    font-size: 40px;
    color: #FFFFFF;
    line-height: 40px;
    margin-top: 46px;
  }
  img {
    width: 60px;
    height: 60px;
    margin-top: 40px;
  }
}



.serve-wrapper {
  height: 1078px;
  position: relative;
  .serve-content {
    width: 100%;
    height: 100%;
    z-index: 11;
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    .top-content {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      font-family: SourceHanSansCN;
      font-weight: 400;
      font-size: 40px;
      color: #FFFFFF;
      line-height: 53px;
      margin-top: 124px;
      margin-bottom: 100px;
    }
    .img-wrapper {
      width: 100%;
      padding: 0px 10%;
      box-sizing: border-box;
      display: flex;
      flex-wrap: wrap;
      .imgs {
        flex: 1 0 33%;
        border-radius: 20px;
        padding: 15px;
        box-sizing: border-box;
        img {
          height: 286px;
          transition: transform 0.1s;
          border-radius: 10px;
          &:hover {
            transform: scale(1.1);
            cursor: pointer;
          }
        }
      }
      .desc {
        margin-top: 45px;
        font-family: SourceHanSansCN;
        font-weight: 400;
        font-size: 32px;
        color: #73788B;
      }
    }
  }
}

.zh {
  .top-content {
    width: 100%;
  }
}
.en {
  .top-content {
    width: 90%;
  }
}

.bg-img {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
}
</style>
